export default __webpack_public_path__ + "static/media/b5.6d16b4fd.png";